import Vue from "vue";

import vueJsonCsv from "vue-json-csv";

export default () => {
  Vue.component("DownloadCsv", vueJsonCsv);
};
